import { FC, useMemo } from "react";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { Navbar } from "@components/navbar";
import { AppMenuNavigate } from "@components/app-menu";
import { AWSUser } from "@archetypes/auth";
import ErrorPageLayout from "@components/error-page-layout";
import Error404Image from "@assets/404.svg";
import { useAppLive } from "@contexts/live-app.context";

const AppsLayout: FC = () => {
  const user = useOutletContext<AWSUser>();

  const {
    appData,
    isFormView,
    isAppView,
    isAppDataLoading,
    appError,
    menuTree,
    showLeftMenu,
    onHamburgerClick,
    onNavbarButtonClick,
  } = useAppLive();

  const { appId } = useParams();

  const context = useMemo(() => {
    return {
      fontColor: appData?.getApp?.fontColor,
      primaryColor: appData?.getApp?.primaryColor,
      secondaryColor: appData?.getApp?.secondaryColor,
      user,
    };
  }, [appData, user]);

  return (
    <main className="main-container">
      <div className="content-area w-100">
        {/* ✅ HEADER */}
        <header className="header-area">
          <Navbar
            basePath="/apps"
            user={user}
            appData={appData?.getApp}
            navbarClassName={showLeftMenu ? "open" : ""}
            onHamburgerClick={onHamburgerClick}
            onNavbarButtonClick={onNavbarButtonClick}
            primaryColor={appData?.getApp?.primaryColor}
          />
        </header>

        <div className="flex justify-center">
          {isAppView && appError ? (
            <ErrorPageLayout
              title={
                (appError as Error & { cause?: { message?: string } }).cause?.message ??
                "Error Fetching App Details"
              }
              image={<img src={Error404Image} alt="error" decoding="async" loading="eager" />}
            />
          ) : (
            <>
              {/* ✅ SIDEBAR */}
              {isAppView && (
                <AppMenuNavigate menuData={menuTree} appId={appId as string} {...context} />
              )}

              {/* ✅ MAIN CONTENT */}
              <div className={`app-content-area ${isAppView || isFormView ? "" : "w-100"}`}>
                {!isAppDataLoading && <Outlet context={context} />}
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
};

export default AppsLayout;
